export const getCookie = (name) => {
    /* eslint-disable */
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
    /* eslint-enable */
}

export const setCookie = (name, value) => {
    value = encodeURIComponent(value);
    document.cookie = name + "=" + value + ";path=/";
}
